import React from "react";

export const SemearFontStyle = () => null;

export const YHUHName = () => (
  <img
    src="/images/yhuh-name.png"
    alt="YaHUaH"
    title="YaHUaH"
    className="inline-block align-baseline h-[1em] w-auto mx-1"
  />
);

export const YHUSHAName = () => (
  <img
    src="/images/yhusha-name.png"
    alt="YaHUSHA"
    title="YaHUSHA"
    className="inline-block align-baseline h-[1em] w-auto mx-1"
  />
);
